module.exports = __webpack_public_path__ + "img/shop9.5863a4c8.jpg";